import React from "react";

import { useParams, useHistory } from "react-router";

import { useQuery } from "@apollo/client";

import PanelTable from "./panel-table";

import PanelCollectionSelect from "./panel-collection-select";
import panelCollectionTableQuery from "./panel-collection-table-query";

interface Props {
  // nodes?: any[];
  // panelCollectionName: String;
}

function PanelCollectionTableContainer(props: Props) {
  // const {
  //   // nodes,
  //   panelCollectionName
  // } = props;
  const { panelCollectionName } = useParams<any>();
  const history = useHistory();
  // const n = nodes ? nodes.join(",") : undefined;
  function onPanelCollectionChange(evt: any) {
    // console.log("onPanelCollectionChange", evt);
    history.push(`/livedata/collections/${evt /*.name*/}/list`);
  }
  const { data, error: metaError, loading: metaLoading } = useQuery(
    panelCollectionTableQuery,
    {
      variables: {
        panelCollectionName: panelCollectionName,
        // node: n,
      },
    }
  );
  if (metaLoading) {
    return <div>Loading...</div>;
  }
  if (metaError) {
    console.error(metaError.message);
    return <div>Error! {metaError.message}</div>;
  }
  return (
    <>
      {/* <Grid justify="space-between" alignItems="center" container>
        <Grid item> */}
      <PanelCollectionSelect
        name="panelCollectionSelect"
        label="" // "Filter"
        value={panelCollectionName}
        onChange={onPanelCollectionChange}
      />
      {/* </Grid>
        <Grid item>
          <Options />
        </Grid> */}
      <PanelTable metaData={data.table} />
    </>
  );
}

export default PanelCollectionTableContainer;
